<template>
  <div class="boss-main-container">
    <interview-register-form
      :interview-countermeasure-id="Number($route.params.interviewCountermeasureId)"
      @submit="update"
    />
  </div>
</template>

<script>
import InterviewRegisterForm from '@/components/organisms/InterviewRegisterForm'

export default {
  components: {
    InterviewRegisterForm
  },
  methods: {
    update (data) {
      this.$http.secured.put(`/interview_countermeasures/${this.$route.params.interviewCountermeasureId}`, data.params)
        .then(response => {
          this.$toasted.global.success({ message: '面接情報を更新しました。' })
          data.isSettings
            ? this.$router.push({ name: 'interviewSettings', params: { interviewCountermeasureId: this.$route.params.interviewCountermeasureId } })
            : this.$router.push({ name: 'interviewTop' })
        })
    }
  }
}
</script>
